import tippy from "tippy.js";

/**
 * Handle tooltip
 *
 * @param container {HTMLElement} container element
 */

const Tooltip = (target: HTMLElement): void => {
  tippy(target, {
    // parse `content` strings as HTML
    allowHTML: true,
    trigger: "click",
    interactive: true,
    arrow: true,
    theme: "kb",
  });
};

export default Tooltip;
